//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import Activity from '../../components/activity/Activity'
import {
  activityList
} from '../../service/index'
import moment from 'moment';
export default {
  data() {
    return {
      campaignList: [],
      showOutdated:true
      // onCampaignList: [],
      // pendingCampaignList: [],
      // offCampaignList: [],
    }
  },
  components: {
    Activity
  },
  mounted() {
    this.getCampaignList()
    this.keepLang()
  },
  computed: {
    ...mapState([
      "global"
    ]),
    onCampaignList() {
      let _onCampaignList = []
      let now = moment(new Date());
      this.campaignList.forEach((item, index) => {
        if (now.isBetween(moment(item.begin),moment(item.end))) {
          _onCampaignList.push(item)
        }
      })
      return _onCampaignList
    },
    offCampaignList() {
      let _offCampaignList = []
      let now = moment(new Date());
      this.campaignList.forEach((item, index) => {
        if (now.isSameOrAfter(moment(item.end).add(7, 'd'))) {
          _offCampaignList.push(item)
        }
      })
      return _offCampaignList
    }
  },
  methods: {
    ...mapMutations({
      chooseCampaign: 'INIT_CAMPAIGN',
      initCampaignList: 'INIT_CAMPAIGN_LIST'
    }),
    toggleOutdate(bool){
      this.showOutdated=bool
    },
    async getCampaignList() {
      const res = await activityList();
      if (res.status === 0) {
        this.campaignList = res.data
        this.initCampaignList(res.data)
      }
    },
    // 中英文切换事件
    switchLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh';
        localStorage.locale = 'zh';
      } else {
        this.$i18n.locale = 'en';
        localStorage.locale = 'en';
      }
    },
    // 刷新页面保存语言
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
    openPop(id) {
      //this.chooseCampaign({id})
      this.$router.push({
        path: `/home/${id}`,
        query: {
          cid: id
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/activity/Activity.vue